<button type="button" class="btn btn-text-gray btn-icon pl-0" (click)="recordingsMainService.changeView(1)">
    <svg><use href="../App_Themes/clearview-default/icons/utility/arrow-left.svg#arrow-left"></use></svg>
    <span cvLocalizedText langSection="Common" langKey="Back_Button">Back</span>
</button>

<!--Navigation-->
<div class="d-flex justify-content-between align-items-center mt-2">
    <button type="button" class="btn btn-secondary" (click)="openPreviousRecording()" [disabled]="selectedApplicationId > 0 || recordingsMainService.IndexForDetails <= 0"
            cvLocalizedText langSection="Common" langKey="Previous_Button">Previous</button>

    <div class="font-size-20">{{recordingsMainService.IndexForDetails + 1}} <span cvLocalizedText langSection="AgGrid" langKey="of">of</span> {{recordingsMainService.recordings.length}}</div>

    <button type="button" class="btn btn-secondary" (click)="openNextRecording()" [disabled]="selectedApplicationId > 0 || recordingsMainService.IndexForDetails >= recordingsMainService.recordings.length - 1"
            cvLocalizedText langSection="Common" langKey="Next_Button">Next</button>
</div>

<!--Details Table-->
<div class="content mt-3" style="height:240px">
    <div class="infieldReadOnlyHolder noBottomBorder w-50">
        <span class="infieldReadOnlyHeader" cvLocalizedText langSection="Recordings" langKey="CONTACT_ID">CONTACT ID</span>
        <span class="infieldReadOnlyValue recInfo text-truncate">{{recordingsMainService.recordingForDetails.ContactID}}</span>
    </div>

    <div class="infieldReadOnlyHolder noBottomBorder noLeftBorder w-50">
        <span class="infieldReadOnlyHeader" cvLocalizedText langSection="Recordings" langKey="DATE">DATE</span>
        <span class="infieldReadOnlyValue text-truncate">{{formatDateField(recordingsMainService.recordingForDetails.RecordingDate_UTC)}}</span>
    </div>

    <div class="infieldReadOnlyHolder noBottomBorder w-50">
        <span class="infieldReadOnlyHeader" cvLocalizedText langSection="Recordings" langKey="CONTACT_SOURCE">CONTACT SOURCE</span>
        <span class="infieldReadOnlyValue text-truncate">{{recordingsMainService.recordingForDetails.ContactSource}}</span>
    </div>

    <div class="infieldReadOnlyHolder noBottomBorder noLeftBorder w-50">
        <span class="infieldReadOnlyHeader" cvLocalizedText langSection="Recordings" langKey="TIME">TIME</span>
        <span class="infieldReadOnlyValue text-truncate">{{formatTimeField(recordingsMainService.recordingForDetails.RecordingDate_UTC)}}</span>
    </div>

    <div class="infieldReadOnlyHolder noBottomBorder w-50">
        <span class="infieldReadOnlyHeader" cvLocalizedText langSection="Recordings" langKey="DISPOSITION">DISPOSITION</span>
        <span class="infieldReadOnlyValue text-truncate">{{recordingsMainService.recordingForDetails.Disposition}}</span>
    </div>

    <div class="infieldReadOnlyHolder noBottomBorder noLeftBorder w-50">
        <span class="infieldReadOnlyHeader" cvLocalizedText langSection="Recordings" langKey="LENGTH">LENGTH</span>
        <span class="infieldReadOnlyValue text-truncate">{{recordingsMainService.recordingForDetails.Length}}</span>
    </div>

    <div class="infieldReadOnlyHolder allowIcon noBottomBorder d-flex align-items-center w-50">
        <span class="infieldReadOnlyHeader" cvLocalizedText langSection="Recordings" langKey="OTHER_ID">OTHER ID</span>
        <span class="infieldReadOnlyValue align-self-start text-truncate" *ngIf="!editingOtherId">{{recordingsMainService.recordingForDetails.OtherID}}</span>

        <div class="d-flex w-100" *ngIf="editingOtherId">
            <!--This span is for spacing purposes-->
            <span class="font-size-10 invisible" style="margin-left:5px; letter-spacing:1px" cvLocalizedText langSection="Recordings" langKey="OTHER_ID">OTHER ID</span>
            <input class="form-control ml-2" type="text" [(ngModel)]="editedOtherId" (keypress)="recordingsMainService.numberOnly($event)" (paste)="recordingsMainService.pasteNumberOnly($event)"
                   [disabled]="isSavingOtherId" />
        </div>

        <div class="flex-grow-1"></div>

        <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="editedOtherId = recordingsMainService.recordingForDetails.OtherID; editingOtherId = true" *ngIf="!editingOtherId">
            <svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/edit.svg#edit"></use></svg>
        </button>

        <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="editingOtherId = false" [disabled]="isSavingOtherId" *ngIf="editingOtherId">
            <svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>
        </button>

        <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="updateOtherId()" [disabled]="isSavingOtherId" *ngIf="editingOtherId">
            <svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/checkmark.svg#checkmark"></use></svg>
        </button>
    </div>

    <div class="infieldReadOnlyHolder allowIcon noBottomBorder noLeftBorder d-flex align-items-center w-50">
        <span class="infieldReadOnlyHeader" cvLocalizedText langSection="Recordings" langKey="FLAGS">FLAGS</span>
        <span class="infieldReadOnlyValue text-truncate" *ngIf="!editingFlags">{{formatFlagNames(recordingsMainService.recordingForDetails.Flags)}}</span>

        <div class="d-flex w-100" *ngIf="editingFlags">
            <!--This span is for spacing purposes-->
            <span class="font-size-10 invisible" style="margin-left:5px; letter-spacing:1px" cvLocalizedText langSection="Recordings" langKey="FLAGS">FLAGS</span>
            <cv-multi-select class="ml-2" [options]="recordingsMainService.flags" [(value)]="editedFlagIds" primaryKey="RecordingFlagID" label="RecordingFlagName" [disabled]="isSavingFlags"
                             [showSelectedToggle]="true"></cv-multi-select>
        </div>

        <div class="flex-grow-1"></div>

        <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="openFlagsForEditing()" *ngIf="!editingFlags">
            <svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/edit.svg#edit"></use></svg>
        </button>

        <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="editingFlags = false" [disabled]="isSavingFlags" *ngIf="editingFlags">
            <svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>
        </button>

        <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="updateFlags()" [disabled]="isSavingFlags" *ngIf="editingFlags">
            <svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/checkmark.svg#checkmark"></use></svg>
        </button>
    </div>

    <div class="infieldReadOnlyHolder noBottomBorder w-100">
        <span class="infieldReadOnlyHeader" cvLocalizedText langSection="Recordings" langKey="GROUP">GROUP</span>
        <span class="infieldReadOnlyValue text-truncate">{{formatGroupNames(true)}}</span>
    </div>

    <div class="infieldReadOnlyHolder w-100">
        <span class="infieldReadOnlyHeader" cvLocalizedText langSection="Recordings" langKey="CAMPAIGN">CAMPAIGN</span>
        <span class="infieldReadOnlyValue text-truncate">{{formatGroupNames(false)}}</span>
    </div>
</div>

<!--Recording Playback-->
<div class="font-size-20 mt-3" cvLocalizedText langSection="Recordings" langKey="Recording_Playback">Recording Playback</div>

<div class="color-valyrianSteel text-center" *ngIf="recordingsMainService.recordingForDetails.RecordingType != 0"
     cvLocalizedText langSection="Recordings" langKey="No_Recording_Available">No recording is available for playback</div>

<div class="audioPlayerContainer w-100 mt-1" *ngIf="recordingsMainService.recordingForDetails.RecordingType == 0">
    <div class="audioPlayerWithControls">
        <audio id="audioPlayer" class="border rounded-pill w-100" controls="controls" controlsList="nodownload">
            <source [src]="recordingsMainService.recordingForDetails.AudioUrl" type="audio/mpeg" class="html5Player_mp3Source" />
        </audio>

        <div class="d-flex">
            <div class="playbackSpeedControlsContainer ml-0" style="width:94px; height:18px">
                <span class="increasePlaybackSpeed clickable"></span>

                <div class="currentPlaybackRateContainer mt-0">
                    <span class="currentPlaybackRate">1.4x</span>
                </div>

                <span class="decreasePlaybackSpeed clickable"></span>
            </div>

            <button type="button" class="btn btn-text btn-icon fill-cerulean" style="outline:none" (click)="handleAudioDownload()">
                <svg><use href="../App_Themes/clearview-default/icons/utility/save.svg#save"></use></svg>
                <span cvLocalizedText langSection="Recordings" langKey="Download_Audio">Download Audio</span>
            </button>
        </div>
    </div>
</div>

<!--Transcript-->
<div class="mt-3" *ngIf="recordingsMainService.recordingForDetails.RecordingType == 1">
    <div class="font-size-20" cvLocalizedText langSection="Recordings" langKey="Transcript">Transcript</div>
    <div class="color-valyrianSteel text-center" *ngIf="!recordingsMainService.recordingForDetails.Transcript" cvLocalizedText langSection="Recordings" langKey="No_Transcript_Found">No transcript found</div>
    <div>{{recordingsMainService.recordingForDetails.Transcript}}</div>
</div>

<!--Notes-->
<div class="font-size-20 mt-3" cvLocalizedText langSection="Recordings" langKey="Notes">Notes</div>
<div class="color-valyrianSteel text-center" *ngIf="!recordingsMainService.recordingForDetails.Notes" cvLocalizedText langSection="Recordings" langKey="No_Notes_Added">No notes have been added</div>
<div>{{recordingsMainService.recordingForDetails.Notes}}</div>

<!--Monitoring-->
<div class="mt-3" *ngIf="recordingsMainService.accessData.MonitorRecordingAccess && selectedApplicationId == 0">
    <!--add ngIf based on security when available-->
    <div class="font-size-20" cvLocalizedText langSection="Recordings" langKey="Monitoring_Available_Forms">Monitoring - Available Forms</div>
    <div class="color-valyrianSteel text-center" *ngIf="MonitoringData?.length == 0"
         cvLocalizedText langSection="Recordings" langKey="No_Monitorable_Applications">No applications are available to monitor</div>

    <div *ngIf="recordingsMainService.recordingForDetails.Monitorable">
        <div class="d-flex mt-2" *ngFor="let data of MonitoringData">
            <button type="button" class="btn btn-secondary" (click)="displayFormClick(data.ApplicationDto.ApplicationID, false)" *ngIf="!data.MonitoredRecordingDto"
                    cvLocalizedText langSection="Recordings" langKey="Monitor">Monitor</button>

            <button type="button" class="btn btn-secondary" (click)="displayFormClick(data.ApplicationDto.ApplicationID, false)" *ngIf="data.MonitoredRecordingDto"
                    cvLocalizedText langSection="Recordings" langKey="Edit">Edit</button>

            <div class="ml-2 pl-1 align-self-center text-truncate" *ngIf="!data.MonitoredRecordingDto">
                <span>{{data.ApplicationDto.ApplicationName + " - "}}</span>
                <span cvLocalizedText langSection="Recordings" langKey="Not_Monitored">Not Monitored</span>
            </div>

            <div class="ml-2 pl-1 align-self-center text-truncate" *ngIf="data.MonitoredRecordingDto">{{formScoreString(data, true)}}</div>
        </div>
    </div>
</div>

<!--Calibration-->
<div class="mt-3" *ngIf="recordingsMainService.accessData.CalibrationRecordingAccess && selectedApplicationId == 0">
    <!--add ngIf based on security when available-->
    <div class="font-size-20" cvLocalizedText langSection="Recordings" langKey="Calibration_Available_Forms">Calibration - Available Forms</div>
    <div class="color-valyrianSteel text-center" *ngIf="CalibrationData?.length == 0"
         cvLocalizedText langSection="Recordings" langKey="No_Calibratable_Applications">No applications are available to calibrate</div>

    <div *ngIf="recordingsMainService.recordingForDetails.Monitorable">
        <div class="d-flex mt-2" *ngFor="let data of CalibrationData">
            <button type="button" class="btn btn-secondary" (click)="displayFormClick(data.ApplicationDto.ApplicationID, true)" *ngIf="!data.CalibrationRecordingDto"
                    cvLocalizedText langSection="Recordings" langKey="Calibrate">Calibrate</button>

            <button type="button" class="btn btn-secondary" (click)="displayFormClick(data.ApplicationDto.ApplicationID, true)" *ngIf="data.CalibrationRecordingDto"
                    cvLocalizedText langSection="Recordings" langKey="Edit">Edit</button>

            <div class="ml-2 pl-1 align-self-center text-truncate" *ngIf="!data.CalibrationRecordingDto">
                <span>{{data.ApplicationDto.ApplicationName + " - "}}</span>
                <span cvLocalizedText langSection="Recordings" langKey="Not_Calibrated">Not Calibrated</span>
            </div>

            <div class="ml-2 pl-1 align-self-center text-truncate" *ngIf="data.CalibrationRecordingDto">{{formScoreString(data, false)}}</div>
        </div>
    </div>
</div>

<!--Form Display-->
<div class="mt-3" *ngIf="selectedApplicationId > 0">
    <cv-form-display [recordingId]="recordingsMainService.recordingForDetails.RecordingID" [applicationId]="selectedApplicationId" [viewOnly]="false"
                     [isCalibration]="isCalibration" [includeDelete]="true" (buttonClick)="handleFormClose($event)"></cv-form-display>
</div>

<div class="d-flex justify-content-end mt-3" *ngIf="recordingsMainService.accessData.MonitorableStatusAccess && selectedApplicationId == 0">
    <button type="button" class="btn btn-secondary" (click)="toggleMonitoringFlag()" [disabled]="!AllowRemoveMonitoring">
        <span *ngIf="recordingsMainService.recordingForDetails.Monitorable" cvLocalizedText langSection="Recordings" langKey="Remove_from_Monitoring">Remove from monitoring</span>
        <span *ngIf="!recordingsMainService.recordingForDetails.Monitorable" cvLocalizedText langSection="Recordings" langKey="Add_to_Monitoring">Add to monitoring</span>
    </button>
</div>
